import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/jg-logo-t.webp")